




























import { helpers, required } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';

export default {
    name: 'ExtendJobModal',

    props: {
        job: {
            required: true,
            type: Object,
        },
    },

    setup(props, context) {
        const { $store } = useNuxtApp();

        const isBursary = computed(() => props.job.job_type === 'Bursary');
        const modelType = computed(() => (isBursary.value ? 'bursary' : 'job post'));
        const error = ref<string | null>(null);

        const form = reactive({
            university_scope: null,
        });

        const rules = computed(() => ({
            university_scope: {
                required: helpers.withMessage('The University Scope field is required.', required),
                $lazy: true,
            },
        }));

        const v$ = useVuelidate(rules, form);

        const submit = async () => {
            await v$.value.$validate();

            if (v$.value.$invalid) return;

            $store
                .dispatch('jobs/single/extendJobPost', {
                    job_uuid: props.job.uuid,
                    university_scope: form.university_scope,
                })
                .then(() => {
                    context.emit('submitted');
                })
                .catch((err) => {
                    error.value = err.response.data.message;
                });
        };

        return {
            error,
            form,
            modelType,
            submit,
            v$,
        };
    },
};
